import { IElementToSimpleSapElementMapperFactory } from '../IElementToSimpleSapElementMapperFactory';
import Element, { ElementType, SpecyficType } from '@/models/element';
import { IElementToSimpleSamElementsMapper } from '../elementToSimpleSapElementsMapper';
import { DeskBodyToSimpleSapElementMappper } from './deskBodyToSimpleSapElementMapper';
import { NullToSimpleSapELementMapper } from '../nullToSimpleSapElementMapper';
import { DeskWallToSimpleSapElementMapper } from './deskWallToSimpleSapElementMapper';
import { HandleToSimpleSapElementMapper } from '../handleToSimpleSapElementMapper';
import { DeskDrawerToSimpleSapElementMapper } from './deskDrawerToSimpleSapElementMapper';
import { DeskLegsToSimpleSapElementMapper } from './deskLegsToSimpleSapElementMapper';
import { DeskFrontToSimpleSapElementMapper } from './deskFrontToSimpleSapElementMapper';

export class DeskElementToSimpleSapElementMapperFactory
    implements IElementToSimpleSapElementMapperFactory {

    private body = new DeskBodyToSimpleSapElementMappper();
    private front = new DeskFrontToSimpleSapElementMapper();
    private wall = new DeskWallToSimpleSapElementMapper();
    private drawer = new DeskDrawerToSimpleSapElementMapper();
    private handle = new HandleToSimpleSapElementMapper();
    private legs = new DeskLegsToSimpleSapElementMapper();
    private null = new NullToSimpleSapELementMapper();

    public getMapperFor(element: Element): IElementToSimpleSamElementsMapper {
        if (element.type === ElementType.BODY) {
            return this.body;
        }
        if (element.type === ElementType.FRONT) {
            return this.front;
        }
        if (element.type === ElementType.WALL) {
            return this.wall;
        }
        if (element.specyficType === SpecyficType.DRAWER) {
            return this.drawer;
        }
        if (element.type === ElementType.HANDLE) {
            return this.handle;
        }
        if (element.type === ElementType.LEGS) {
            return this.legs;
        }
        return this.null;
    }
}